import type { EventTicketSummary, TicketOrderListItem } from '@pulsify/shared/dto'

export type EventPhase = 'upcoming' | 'live' | 'past' | 'canceled'

type WithTickets = Pick<TicketOrderListItem, 'tickets'>

export function eventPhase(
  event: Pick<EventTicketSummary['event'], 'startTime' | 'endTime' | 'isCanceled'>,
  now: Date,
): EventPhase {
  if (event.isCanceled) return 'canceled'
  if (now < new Date(event.startTime)) return 'upcoming'
  return now <= new Date(event.endTime) ? 'live' : 'past'
}

export function fillRatio(part: number, whole: number | null): number | null {
  if (whole === null || whole <= 0) return null
  return Math.min(Math.max(part / whole, 0), 1)
}

export function activeTickets(order: WithTickets): TicketOrderListItem['tickets'] {
  return order.tickets.filter((ticket) => ticket.status === 'active')
}

export function entryOf(order: WithTickets): { checkedIn: number; valid: number } {
  const valid = activeTickets(order)
  return {
    checkedIn: valid.filter((ticket) => ticket.checkedInAt !== null).length,
    valid: valid.length,
  }
}
